import {
  ContractDetailTabsProvider,
  vsProviderName as ContractDetailTabsProviderName,
} from "./contractDetailTabsService";

import { vsComponentName as machineViewComponentName } from "../../../../../../views/machines/component";
import { vsComponentName as ContractMachinesEditComponentName } from "../../../../../../views/machines/edit";
import {
  vsName as GridSettingsServiceName,
  GridSettingsService,
} from "../../../../../../../records/grids/settings/gridSettingsService";
import {
  vsName as serverUtilityName,
  ServerUtility,
} from "../../../../../../../records/server/serverUtility";
import { ServiceResponse } from "../../../../../../../records/server/query";

export function contractDetailTabsConfig(
  contractDetailTabsProvider: ContractDetailTabsProvider
) {
  contractDetailTabsProvider.addElement({
    id: "Machine",
    displayName: "Machine",
    uiSrefFragment: "Machine",
    stateDefinition: {
      component: machineViewComponentName,
      url: "/machines",
      resolve: {
        gridSettings: [
          GridSettingsServiceName,
          (gridSettingsService: GridSettingsService) =>
            gridSettingsService.getGridSettings(Symbol("contract.machineView")),
        ],
      },
    },
    children: [
      {
        displayName: "Edit",
        id: "edit",
        uiSrefFragment: "edit",
        stateDefinition: {
          url: "/edit",
          component: ContractMachinesEditComponentName,
          resolve: {
            contractMachines: [
              serverUtilityName,
              "contractId",
              function (serverUtility: ServerUtility, contractId: number) {
                return serverUtility
                  .sendApiRequest({
                    method: "get",
                    url: `api/contract/contractMachines/${contractId}`,
                  })
                  .then((r) => (<ServiceResponse<unknown>>r).Results);
              },
            ],
          },
        },
      },
    ],
  });
}

contractDetailTabsConfig.$inject = [ContractDetailTabsProviderName];
